import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, Inject } from '@angular/core';
import { RequisicaoExternaService } from '@services/requisicaoexterna.service';
import { UtilService } from '@services/util.service';

@Component({
  selector: 'app-tuneis',
  templateUrl: './tuneis.component.html',
  styleUrls: ['./tuneis.component.css'],
})

export class TuneisComponent implements AfterViewInit {
  utilService: UtilService;
  constructor(private requisicaoExternaService: RequisicaoExternaService, @Inject(DOCUMENT) public document: Document) {
  }

  ngAfterViewInit(): void {
    this.functionAtualizarRelatorioTomus();
  }

  functionAtualizarRelatorioTomus = () => {
    this.requisicaoExternaService.ObterResultado("tuneis").subscribe(resultado => {
      var referenciaElementoTestado = this.document.getElementById("iframeTuneis") as HTMLIFrameElement;
      var parteToken = resultado.resultadoRequisicao.split(' ');
      referenciaElementoTestado.src = 'https://smsub.tiindustrial.com.br/login?page=monitoring-tunnel-table&token=' + parteToken[1];
    });
  }
}
